var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppLayout from '@/Layouts/AppLayout';
import Tabs from '@/Jetstream/Tabs';
import { CalendarIcon, InboxIcon, PencilIcon } from "@heroicons/react/24/outline";
import useTypedPage from "@/Hooks/useTypedPage";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import { ExternalLinkIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function BookingLayout(_a) {
    var _b, _c, _d, _e, _f;
    var team = _a.team, title = _a.title, pageTitle = _a.pageTitle, breadCrumb = _a.breadCrumb, children = _a.children;
    var route = useRoute(Ziggy);
    var current = window.location.href.replace(/\?.*/, '');
    var page = useTypedPage();
    return (_jsxs(AppLayout, __assign({ title: title, pageTitle: pageTitle, breadCrumb: breadCrumb }, { children: [_jsx(Tabs, { tabs: [
                    {
                        id: 'certificates-tab',
                        name: 'Bookings',
                        icon: InboxIcon,
                        href: route('team.calendar.show', {
                            team: page.props.team,
                            calendar: page.props.calendar
                        }),
                        current: route().current('team.calendar.show', {
                            team: page.props.team,
                            calendar: page.props.calendar
                        }),
                    },
                    {
                        id: 'calendar-tab',
                        name: 'Calendar',
                        icon: CalendarIcon,
                        href: route('team.calendar.week', {
                            team: page.props.team,
                            calendar: page.props.calendar
                        }),
                        current: route().current('team.calendar.week', {
                            team: page.props.team,
                            calendar: page.props.calendar
                        }),
                        // count: branch.certificates_count,
                    },
                ].filter(Boolean) }), _jsxs("div", __assign({ className: "p-4 border-b text-sm flex justify-between items-center" }, { children: [_jsxs("div", __assign({ className: "" }, { children: [_jsxs("div", __assign({ className: "flex" }, { children: [_jsx("div", __assign({ className: "font-bold uppercase w-32 text-xs" }, { children: "Name" })), (_b = page.props.calendar) === null || _b === void 0 ? void 0 : _b.name, _jsx("a", __assign({ href: route('team.calendar.edit', { team: team, calendar: page.props.calendar }), className: "ml-2 text-sky-600" }, { children: _jsx(PencilIcon, { className: "h-3 w-3" }) }))] })), _jsxs("div", __assign({ className: "flex" }, { children: [_jsx("div", __assign({ className: "font-bold uppercase w-32 text-xs" }, { children: "Branch" })), (_d = (_c = page.props.calendar) === null || _c === void 0 ? void 0 : _c.branch) === null || _d === void 0 ? void 0 : _d.name, _jsx("a", __assign({ href: route('team.calendar.edit', { team: team, calendar: page.props.calendar }), className: "ml-2 text-sky-600" }, { children: _jsx(PencilIcon, { className: "h-3 w-3" }) }))] })), _jsxs("div", __assign({ className: "flex" }, { children: [_jsx("div", __assign({ className: "font-bold uppercase w-32 text-xs" }, { children: "Vet" })), (_f = (_e = page.props.calendar) === null || _e === void 0 ? void 0 : _e.vet) === null || _f === void 0 ? void 0 : _f.name, _jsx("a", __assign({ href: route('team.calendar.edit', { team: team, calendar: page.props.calendar }), className: "ml-2 text-sky-600" }, { children: _jsx(PencilIcon, { className: "h-3 w-3" }) }))] }))] })), _jsx(Button, __assign({ asChild: true, variant: "outline" }, { children: _jsxs("a", __assign({ href: route('booking-landing', { calendar: page.props.calendar }), target: "_blank" }, { children: ["Booking page", _jsx(ExternalLinkIcon, { className: "ml-2 w-4 h-4" })] })) }))] })), children] })));
}
